import React from 'react';
import {BsInstagram, BsGithub} from 'react-icons/bs';
import {FaSoundcloud} from 'react-icons/fa';


const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a target="_blank" href="https://www.instagram.com/germanmrojas/?hl=en"> 
              <BsInstagram/>
            </a>

        </div>
        <div>
          <a target="_blank" href="https://github.com/grojas2525"> 
            <BsGithub/>
          </a>

        </div>
        <div>
          <a target="_blank" href="https://soundcloud.com/german-rojas-974995843?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"> 
            <FaSoundcloud/>
          </a>
        </div>
    </div>
  )
}

export default SocialMedia